import React, { useState, useEffect } from "react";
import { Column } from "@ant-design/plots";
import { forEach, groupBy } from 'lodash-es';

const StackColumnChart = ({ data, yLabel,xLabel, series, color, yAxisLabel, xAxisLabel, xField, yField }) => {
  //const data = props.data;
  const [chartColor, setChartColor] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    "this is the data...", data;
    if (color === "stemi") {
      setChartColor(["#16ada0", "#239b56", "#32669e", "#4945a8"]);
    }
    else if(color === "stemiProvince")
    {  
      setChartColor( ["#4945a8", "#724dad", "#2193ae", "#32669e", "#00B3E6", "#E6B333", "#3366E6"]);
    }
    else if(color === "stemiGrade"){
      setChartColor([
        "#21618c",
        "#487386",
        "#8db05c",
        "#00b8e6",
        "#387c9f",
        "#ac85cb",
        "#3366E6",
        "#f9c232",
        "#2b8a84",
        "#239b56",
        "#34495e",
        "#f7941d",
        "#f7945d",
      ]);
    } 
    else if (color === "Science") {
      //setChartColor(["#302E6D", "#4945A8", "#724DAD", "#A84580", "#f9c232", '#F295BD', "#239b56", "#34495e", '#f7941d']);
      //setChartColor(["#302E6D", "#4945A8", "#724DAD", "#A84580", "#D461B1", '#FB94DC']);//purple,pink
     // setChartColor([ "#302E6D", "#4945A8", "#724DAD", "#32669E",  "#2193AE", "#2FB8B8", "#83DFDF", '#487386', '#2b8a84',  "#487386", "#2b8a84"]) //mixed
      //setChartColor(["#83DFDF", "#2FB8B8", "#2193AE", "#32669E", "#2E4088", "#302E6D", "#25244A"]); //blue gradient
      //setChartColor(["#302E6D", "#4945A8", "#5C399B", "#7A57B1", "#996EBE", "#BB8CE3"]); //purple
     // setChartColor(["#4945A8", "#9CC8FB", "#5B6CA6", "#718AC2", "#86A9DF", "#9CC8FB"]);
      setChartColor([ "#302E6D", "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "#32669E", '#487386', '#2b8a84',  "#487386", "#2b8a84"]) //blue purple
     //setChartColor([ "#302E6D", "#594C87", "#826AA0", "#AC89BA", "#D5A7D3", "#D5A7D3", "#FEC5ED"]) // purple/pink
    }
    else if (color === "OrgsRole") {
      //setChartColor(["#16A085", "#2193AE", "#2159AE", "#4945A8", "#AE43B2", "#34495e", "#f9c232", '#2b8a84', "#239b56", "#34495e", '#f7941d']);
      //setChartColor([ "#302E6D", "#4945A8", "#724DAD", "#32669E",  "#2193AE", "#2FB8B8", "#83DFDF", '#487386', '#2b8a84',  "#487386", "#2b8a84"])
      //setChartColor(["#83DFDF", "#2FB8B8", "#2193AE", "#32669E", "#2E4088", "#302E6D", "#25244A"]);
     // setChartColor(["#83DFDF", "#2FB8B8", "#2193AE", "#32669E", "#2E4088", "#302E6D", "#25244A"]);// blue gradient
      setChartColor([ "#302E6D", "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "#32669E", "#2E4088"]) // mixed
      //setChartColor([ "#302E6D", "#594C87", "#826AA0", "#AC89BA", "#D5A7D3", "D5A7D3", "#FEC5ED"]) // purple/pink
    }
    else if (color === 'orgObjectives') { 
      //setChartColor(["#487386", "#8db05c", '#f9c232', '#f7941d', '#f36523', '#9d405f', "#f9c232", '#2b8a84', "#239b56", "#34495e"])
     // setChartColor(["#302E6D", "#4945A8", "#724DAD", "#A84580", "#D461B1", '#FB94DC']);
     //setChartColor(["#302E6D", "#4945A8", "#5C399B", "#7A57B1", "#996EBE", "#BB8CE3"]); 
     //setChartColor(["#2FB8B8", "#2193AE", "#32669E", "#4945A8", "#724DAD", "#67e67d", "#ff74c2", "#7ca6b4", "#4e4e4e"])
     //setChartColor(["#83DFDF", "#2FB8B8", "#2193AE", "#32669E", "#2E4088", "#302E6D", "#25244A"]);
     //setChartColor(["#2FB8B8", "#2F8A9F", "#305C86", "#302E6D"]);
    // setChartColor(["#BB8CE3","#8D6DBC", "#5E4D94", "#302E6D"]);
     //setChartColor([ "#302E6D", "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "#32669E", '#487386', '#2b8a84',  "#487386", "#2b8a84"])
     setChartColor([ "#4945A8", "#724DAD", "#2FB8B8", "#2193AE", "32669E", "#2E4088"])
     //setChartColor([ "#188fad", "#3f73ac", "#5f5ca1", "#775ba5"])
    }
    else {
      setChartColor(["#2193ae", "#32669e"]);
    }
  };

  const config = {
    data,
    height: 650,
    xField: 'group',
    yField: yLabel,
    stack: true,
    colorField: 'type',
    scale: {
      color: {
        range: chartColor
      },
    },
    label: {
      text: 'value',
      position: 'inside',
    },
    legend: {
      color: {
        title: false,
        position: 'bottom',
        rowPadding: 5,
      },
    },
    axis: {
      x: {
        title: xAxisLabel,
        style: {
          titleFill: 'black',
        },
        labelFormatter: (text) => text.length > 10 ? text.slice(0, 10) + '...' : text, // Ellipsis for long labels
      },
      y: {
        title: yAxisLabel,
        style: {
          titleFill: 'black'
        }
      }
    },
    style: {
      maxWidth: 50,
    },
  };

  return <Column {...config} />;
};

export default StackColumnChart;
